<template>
  <div :class="['usage-details', closing ? 'closing' : 'opening']" :style="style">
    <div class="details" >
      <div class="top">
        <div class="date-time">
          <div class="day">Aanmaken</div>
        </div>
        <div class="flex">
          <div class="close" style="margin:0 10px 0 0" @click="save">
            <span><i class="fas fa-check"></i></span>
          </div>
          <div class="close" @click="close()">
            <span class="bold">X</span>
          </div>
        </div>
      </div>
      <div v-if="!dayIsKnown">
      <br>
      <p>Kies de dag van het gebruiksmoment</p>
      <br>
      <input type="date" v-model="chosenDayInput" name="" id="">
      <br>
      <br>
      <button @click="chooseTimeClick">Kies tijd</button>
      </div>
      <div v-else class="bottom">
        <div class="info">
          <p>Vul een start- en eindmoment in.</p>
          <p>
            <span>Van:</span>
            <span class="preset-date" @click="editing = true">{{getDate(newStartTimestamp)}}</span>
          </p>
          <p>
            <span>Tot:</span>
            <span class="preset-date" @click="editing = true">{{getDate(newEndTimestamp)}}</span>
          </p>
          <button class="change-day" @click="changeDay">Dag aanpassen</button>
        </div>

        <div class="hours" :key="update">
          <div v-for="halfHour in halfHours" :key="halfHour.timestamp" :class="['hour', halfHour.active ? 'active' : '']" @click="select(halfHour.timestamp)">
            {{new Date(halfHour.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}}
          </div>
        </div>

        <input name="weekly" v-model="weekly" type="checkbox">
        <label for="weekly">Wekelijks</label>
      </div>
    </div>
  </div>
</template>

<script>

import jwt_decode from 'jwt-decode'

const HALF_HOUR = 1000 * 1800;
const HOUR = HALF_HOUR * 2;
const DAY = HOUR * 24;

export default {
  name: 'UsageDetails',
  props: {
    user: {
      type: Object
    },
    startTimestamp: {
      type: Number
    },
    endTimestamp: {
      type: Number
    }
  },
  data() {
    return {
      editing: false,
      newStartTimestamp: 0,
      newEndTimestamp: 0,
      userId: parseInt(jwt_decode(localStorage.getItem('token')).id),
      isUpdating: false,
      closing: false,
      weekly: false,
      assignStart: true,
      update: 0,
      chosenDayInput: null
    }
  },
  methods: {
    changeDay() {
      this.newStartTimestamp = 0;
      this.newEndTimestamp = 0;
    },
    chooseTimeClick() {
      const day = new Date(this.chosenDayInput);

      const EIGHT_HOURS = HOUR * 8;

      this.newStartTimestamp = day.getTime() + EIGHT_HOURS;
      this.newEndTimestamp = day.getTime() + EIGHT_HOURS + EIGHT_HOURS;
    },
    select(timestamp) {
      if (timestamp < this.newStartTimestamp) {
        this.newStartTimestamp = timestamp;
        this.assignStart = false;
      } else if (timestamp > this.newEndTimestamp) {
        this.newEndTimestamp = timestamp;
        this.assignStart = true
      } else {
        if (this.assignStart)
          this.newStartTimestamp = timestamp;
        else
          this.newEndTimestamp = timestamp;

        this.assignStart = !this.assignStart;
      }
      this.update += 1;
    },
    save() {
      if (!this.newStartTimestamp || !this.newEndTimestamp) {
        alert('Kies een start- en eindmoment')
        return;
      }

      if (new Date(this.newEndTimestamp).toLocaleDateString() !== new Date(this.newStartTimestamp).toLocaleDateString()) {
        alert('Het start- en eindmoment moeten op dezelfde dag vallen.');
        return;
      }

      const loadMessage = this.weekly ? 'Gebruiksmomenten worden opgeslagen...' : 'Gebruiksmoment wordt opgeslagen...'

      this.global.GetBaseView().startLoad(loadMessage);

      const token = localStorage.getItem('token');
      this.isUpdating = true;

      this.axios.post(this.config.api + '/usages', {
        userId: this.userId,
        fromTimestamp: this.newStartTimestamp,
        toTimestamp: this.newEndTimestamp,
        weekly: this.weekly
      }, {
        headers: {
          authorization: token
        }
      })
        .then(result => {
          this.global.GetBaseView().endLoad();
          if (result.data.status) {
            this.isUpdating = false;
            this.close();
            this.$emit('created')
          } else {
            alert('De opgegeven momenten zijn reeds gekozen, kies een moment dat vrij is.');
            this.isUpdating = false;
          }
        })
        .catch(error => {
          this.isUpdating = false;
        })
    },
    close() {
      this.closing = true;

      setTimeout(() => {
        this.$emit('close');
      }, 500)
    },
    getDate(timestamp) {
      const dayMap = {
        0: 'Zo',
        1: 'Ma',
        2: 'Di',
        3: 'Wo',
        4: 'Do',
        5: 'Vr',
        6: 'Za'
      }
      const monthMap = [
        'jan.',
        'feb.',
        'maart',
        'apr.',
        'mei.',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
      ];
      const date = new Date(timestamp);
      const dayName = dayMap[date.getDay()];
      const monthName = monthMap[date.getMonth()];

      return `${dayName} ${date.getDate()} ${monthName} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    }
  },
  computed: {
    style: function() {
      return `background-color:${this.user.colour}`
    },
    halfHours: function() {
      if (this.update) {}

      const hours = [];
      for (let i = this.chosenDayStart; i <= (this.chosenDayStart + DAY); i += HALF_HOUR) {
        const active = i >= this.newStartTimestamp && i <= this.newEndTimestamp;

        hours.push({
          timestamp: i,
          active
        });
      }
      return hours
    },
    chosenDayStart: function() {
      const day = new Date(this.newStartTimestamp);
      day.setHours(0, 0, 0, 0);

      return day.getTime();
    },
    dayIsKnown: function() {
      return this.newStartTimestamp && this.newEndTimestamp;
    }
  },
  created() {
    this.newStartTimestamp = this.startTimestamp;
    this.newEndTimestamp = this.endTimestamp;
  }
}
</script>

<style scoped>

.active {
  background-color: #672583;
  color: white;
  border-radius: 5px;
}

.hours {
  display: flex;
  flex-wrap: wrap;
}

.hour {
  width: 46px;
  height: 46px;
  font-size: 12px;

  border-radius: 5px;
  margin: 2px;
  padding: 2px;
}

.closing {
  animation: close .5s 1;
}

.opening {
  animation: fadein .5s 1;
}

.bold {
  font-weight: 700;
}

@keyframes close {
  0% {
    top: 0;
    opacity: 1;
  }
  100% {
    top: 100%;
    opacity: 0;
  }
}

@media (max-height: 700px) {
  .hour {
    width: 36px;
    height: 36px;
    font-size: 10px;

    border-radius: 5px;
    margin: 2px;
    padding: 2px;
  }

  p {
    margin: 0;
    padding: 0;
  }
}


.day {
  display: block;
  font-size: 20px;
}

.name {
  text-decoration: underline;
}

.close {
  background-color: rgba(0, 0, 0, 0.514);
  color: white;

  border-radius: 50%;
  width: 50px;
  height: 50px;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  transition: .2s;
}

.close:active {
  background-color: black;

  transition: .2s;
}

.flex {
  display: flex;
}

.top {
  display: flex;
  justify-content: space-between;
}

.usage-details {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  flex-direction: column;

  padding: 10px;

  user-select: none;

  color: black;

  z-index: 2;
}

.info {
  position: relative;
}

.change-day {
  position: absolute;
  right: 0;
  top: 50%;
}

button.change-day {
  background-image: none;
  background-color: transparent;
  border: 2px solid rgb(0, 0, 0);
  color: rgb(0, 0, 0);
  padding: 2px 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/CreateUsage.vue